/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FormProps } from 'components/form'
import { useRef } from 'react'
import { useParams } from 'react-router'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { SolicitacaoExameModel } from './model-solicitacaoExames'
import SolicitarExamesFormModal, { SolicitarExamesUrlParams } from './SolicitarExamesFormModal'

export interface SolicitarExamesEditarModalProps
  extends Omit<FormProps<SolicitacaoExameModel>, 'initialValues' | 'render'> {
  cidadao: CidadaoAtendimento
  adicionados: SolicitacaoExameModel[]
  iniciadoEm: Instant
  onClose(): void
}

export default function SolicitarExamesEditarModal(props: SolicitarExamesEditarModalProps) {
  const { cidadao, onSubmit, onClose, adicionados, iniciadoEm } = props
  const { id } = useParams<SolicitarExamesUrlParams>()

  const initialValues = useRef<SolicitacaoExameModel>(adicionados?.find((item) => item._id === id))

  return (
    <SolicitarExamesFormModal
      cidadao={cidadao}
      editing={true}
      initialValues={initialValues.current}
      iniciadoEm={iniciadoEm}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  )
}
